<script>
  import {
    PlusIcon,
    XIcon,
    Edit3Icon,
    MailIcon,
  } from 'vue-feather-icons'
  export default {
    components: {
      PlusIcon,
      XIcon,
      Edit3Icon,
      MailIcon,
    },
    props: {
      index: {
        type: Number,
        required: true,
      },
      emailList: {
        type: Array,
        required: true,
      },
      formError: {
        type: Object,
        required: true,
      },
      formErrorPath: {
        type: String,
        required: true,
      },
      enforcePrimary: {
        type: Function,
        default: () => { return false },
      }
    },
    computed: {
    },
    methods: {
      // Email Methods
      addContactEmail() {
        const isPrimary = !this.emailList.length
        this.emailList.push(
          {
            is_primary: isPrimary,
            is_edit: true
          }
        )
      },
      removeContactEmail(indexEmail) {
        const rebindPrimary = this.emailList[indexEmail].is_primary
        this.emailList.splice(indexEmail, 1)
        if (rebindPrimary && this.emailList.length > 0) {
          this.emailList[0].is_primary = true
        }
      },
      toggleEditContactEmail(indexEmail, toggle = true) {
        const email = this.emailList[indexEmail]
        email.is_edit = toggle
        this.$set(this.emailList, indexEmail, email)
      },
      canUpdateEmail(indexEmail){
        const email = this.emailList[indexEmail]
        if (email && email.email && email.email.length > 4 && email.email.indexOf('@') !== -1){
          return true
        }
        return false
      },
      canRemoveEmail(indexEmail){
        const usableEmails = this.emailList.filter(el => el && el.email)
        if (usableEmails && usableEmails.length > 1){
          return true
        }
        return !this.canUpdateEmail(indexEmail)
      },
    },
  };
</script>

<template>
  <BaseCollapseBox label="EMAIL ADDRESSES" name="email_addresses">
    <div v-for="(email, indexEmail) in emailList" :key="indexEmail">
      <div
        v-if="!email.is_edit"
        class="edit-form-item my-3"
        :class="{ 'border-col-error': formError[`${formErrorPath}.${indexEmail}.email`] }">
        <div class="item-info">
          <div class="tw-w-full md:tw-w-2/3 tw-pl-4 left-ct tw-inline-flex tw-items-center" style="justify-content: unset">
            <span v-if="email.is_primary" class="block-status border rounded-pill pl-1 mr-2 md:tw-hidden tw-flex">
              <span class="status-icon status-completed" style="margin-right: 0.25rem;"/>
            </span>
            <MailIcon size="1.2x" class="tw-mr-3  tw-min-w-6"/><p class="tx-value mg-b-0 text-bold tw-overflow-ellipsis tw-truncate"> {{email.email}}</p>
          </div>
          <div class="tw-hidden md:tw-flex tw-w-1/3 right-ct">
            <span v-if="email.is_primary" class="block-status border rounded-pill pl-1 tw-pr-4 md:tw-flex tw-hidden">
              <span class="status-icon status-completed"></span><span>(Primary)</span>
            </span>
          </div>
        </div>
        <div class="action-group mg-l-auto tw-flex-shrink-1">
          <button class="btn btn-icon button-action button-action-positive" @click="toggleEditContactEmail(indexEmail)">
            <Edit3Icon size="1x" class="custom-class"></Edit3Icon>
          </button>
          <button v-if="canRemoveEmail(indexEmail)" class="btn btn-icon button-action button-action-negative" @click="removeContactEmail(indexEmail)">
            <XIcon size="1x" class="custom-class"></XIcon>
          </button>
        </div>
      </div>
      <div v-else class=" border border-radius-20 my-3 tw-px-4 md:tw-px-5 tw-py-4 md:tw-py-5 bg-gray">
        <div class="group-block">
          <div class="tw-flex tw-flex-col lg:tw-flex-row">
            <section class="tw-w-full lg:tw-w-3/4 tw-flex tw-flex-col sm:tw-flex-row">
              <div class="tw-w-full sm:tw-w-2/3">
                <div :class="['form-group', { 'is-invalid': formError[`${formErrorPath}.${indexEmail}.email`] }]">
                  <label>Email</label>
                  <input
                    v-model="emailList[indexEmail].email"
                    type="text"
                    class="form-control"
                    placeholder="E.g. email@customer.com"/>
                  <p v-if="formError && formError[`${formErrorPath}.${indexEmail}.email`]" class="text-danger">{{ formError[`${formErrorPath}.${indexEmail}.email`] }}</p>
                </div>
                <div class="tw-w-full sm:tw-w-1/3 tw-inline-flex tw-items-center tw-justify-center tw-mb-4">
                  <div class="tw-items-start sm:tw-mt-5">
                    <div class="col-md-2 tw-pr-0">
                      <FabricCheckbox
                        v-model="emailList[indexEmail].is_primary"
                        :disabled="emailList[indexEmail].is_primary"
                        slot-classes="!tw-pl-3 tw-text-black"
                        switch
                        is-stacked
                        @update="enforcePrimary(index, 'emails', indexEmail)"
                      >Primary</FabricCheckbox>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <div class="tw-w-full lg:tw-w-1/4 tw-inline-flex tw-items-center tw-justify-around tw-flex-col xs:tw-flex-row lg:tw-flex-col">
              <button
                :disabled="!canUpdateEmail(indexEmail)"
                type="button"
                class="btn button button-dashed-positive tw-min-w-u xs:tw-min-w-2/5 tw-w-40 xs:tw-w-auto tw-mb-2 xs:tw-mb-0 md:tw-w-40 md:tw-min-w-u"
                @click="toggleEditContactEmail(indexEmail, false)"> Save </button>
              <button
                v-if="canRemoveEmail(indexEmail)"
                type="button"
                class="btn button button-dashed-danger tw-min-w-u xs:tw-min-w-2/5 tw-w-40 xs:tw-w-auto md:tw-w-40 md:tw-min-w-u"
                @click="removeContactEmail(indexEmail)"> Remove </button>
            </div>
          </div>
        </div>
      </div>
      <p v-if="!email.is_edit && formError && formError[`${formErrorPath}.${indexEmail}.email`]" class="text-danger">{{ formError[`${formErrorPath}.${indexEmail}.email`] }}</p>
    </div>
    <p v-if="formError && formError[`${formErrorPath}`]" class="text-danger">{{ formError.contacts[index].emails }}</p>
    <div class="group-button">
      <button type="button" class="btn button-bd-dashed" @click="addContactEmail">
        <div class=" fl-al-center">
          <PlusIcon size="1.5x" class="custom-class float-left mr-2"></PlusIcon>
          <span class="item-text">Add Email</span>
        </div>
      </button>
    </div>
  </BaseCollapseBox>
</template>
